import {createStore} from 'vuex'
import sortBy from "lodash/sortBy";
import Locale from "@/Services/Locale";

export default createStore({
  state () {
    return {
      config: {
        locale: 'en',
        headerOffset: 0,
        termsAndConditions: null,
      },

      currency: {
        name: 'euro',
        symbol: '€',
        decimals: 2,
      },

      discount: {
        code: null,
        type: null,
        value: null,
        products: [],
      },

      form: {
        first_name: '',
        last_name: '',
        address: '',
        country_id: null,
        zip: '',
        city: '',
        email: '',
        phone: '',
        comment: '',
        payment_method: null,
        shipping_method_id: null,
      },

      translations: {},

      products: [],

      shippingOptions: [],

      validated: false,
    };
  },

  getters: {
    countries(state) {
      const countries = state.shippingOptions
        .filter(i => i.paymentMethods.length > 0)
        .map(option => ({
          value: option.country.value,
          label: Locale.translate(option.country.name),
        }))
        .sort();

      return sortBy(countries, [(i) => i.label]);
    },

    paymentMethods(state) {
      if (state.shippingOptions.length === 0) return [];

      let index = state.shippingOptions.findIndex(i => i.country.value === state.form.country_id);

      if (index === -1) index = 0;

      return state.shippingOptions[index].paymentMethods;
    },

    shippingOptions(state) {
      if (state.shippingOptions.length === 0) return [];

      let index = state.shippingOptions.findIndex(i => i.country.value === state.form.country_id);

      if (index === -1) index = 0;

      return state.shippingOptions[index].shippingOptions;
    },

    shippingOption(state) {
      const item = state.shippingOptions.find(i => i.country.value === state.form.country_id);

      return item || {};
    },
  },
});
